import { I18N } from "oc-I18N";
import { SavingContext } from "../../hooks/UseSaving";
import { useContext } from "react";
import SaveIcon from "@mui/icons-material/Save";

export function FertigButton() {
  const { save, active } = useContext(SavingContext);
  return (
    <button
      disabled={active}
      className={"primary-button fertig-button large font-size-large"}
      data-button-key="save"
      onClick={async () => {
        APP.logUserAction({ action: "clickSave" }, { stateChange: false });
        if (APP.pageName === "Grundriss") {
          await APP.showPage("Zauneditor");
          await new Promise((resolve) => setTimeout(resolve, 500));
        }
        save();
      }}
      aria-label={I18N("aria::Konfiguration speichern")}
    >
      {/* Mobile view (< 1000px) - Save icon */}
      <div className="mobile-view">
        <SaveIcon style={{ fontSize: "24px" }} />
      </div>

      {/* Desktop view (>= 1000px) - Original text */}
      <div className="desktop-view">{I18N("Speichern")}</div>
    </button>
  );
}
